import Router from "./routes";
import "./App.scss";
import { getPathName } from "./utils";
import { ROUTES } from "./constants";

const App = () => {
  const pathName = getPathName();

  return (
    <div className="cp-base">
      {(pathName === ROUTES.LOGIN || pathName === ROUTES.SIGN_UP) && (
        <>
          <div className="cp-base__ui-corner cp-base__ui-corner--top-left" />
          <div className="cp-base__ui-corner cp-base__ui-corner--bottom-right" />
          <div className="cp-base__tech-lines" />
        </>
      )}

      <Router />
    </div>
  );
};

export default App;
